import api from "../api/API";

const extrairRegistros = (resposta) => {
  if (Array.isArray(resposta?.data)) return resposta.data;
  if (resposta?.data?.status === false) {
    throw new Error(resposta?.data?.message || "Nao foi possivel carregar os lembretes.");
  }
  return resposta?.data?.records || [];
};

export async function listarLembretes(status) {
  const query = status === undefined ? "" : `?status=${status}`;
  const resposta = await api.get(`/lembretes${query}`);
  return extrairRegistros(resposta);
}

export async function criarLembrete(payload) {
  const resposta = await api.post("/lembretes", payload);
  return resposta?.data?.record;
}

export async function atualizarLembrete(id, payload) {
  const resposta = await api.put(`/lembretes/${id}`, payload);
  return resposta?.data?.record;
}

export async function alterarStatus(id, status) {
  const resposta = await api.patch(`/lembretes/${id}/status`, { status });
  return resposta?.data?.record;
}

/**
 * Aceita um numero de minutos (`adiar(id, 60)`) ou um horario exato
 * (`adiar(id, { lembrar_em: iso })`), que e o que as opcoes "Amanha 9h" usam.
 */
export async function adiarLembrete(id, opcoes = 60) {
  const payload = typeof opcoes === "number" ? { minutos: opcoes } : opcoes;
  const resposta = await api.post(`/lembretes/${id}/adiar`, payload);
  return resposta?.data?.record;
}

export async function converterEmTarefa(id, payload) {
  const resposta = await api.post(`/lembretes/${id}/converter`, payload);
  return resposta?.data;
}

export async function removerLembrete(id) {
  await api.delete(`/lembretes/${id}`);
}
